module.exports = __webpack_public_path__ + "static/media/troll.b2ede1b7.gif";